import dayjs from "dayjs";

export const formatHealthCenterDateTime = (value: string): string => {
    const date = dayjs(value);

    return date.isValid() ? date.format("DD.MM.YYYY HH:mm:ss") : "—";
};
